define('views/modules/setting/business/modals/payment-add-method-modal',[
    // Libs
    "underscore",
    "backbone",
    "mustache",
    "utils",
    "debug",
    "toastr",
    //services
    "services/i18n",
    "services/api",
    "services/session",
    //models
    "models/payment/payment-method",
    // views
    "views/parts/modal/modal",
    "views/modules/setting/business/payment/payment-current-plan",
    "views/modules/setting/business/payment/payment-safety-notice",
    "views/modules/setting/business/payment/payment-method-form",
    "views/modules/setting/business/payment/payment-informations-form",
    "views/modules/setting/business/payment/billing-informations-form",
    "views/parts/info-section",
    // templates
    "text!templates/modules/setting/business/modals/payment-add-method-modal.html",
    "text!templates/modules/setting/business/payment/payment-messages.html",
    "text!templates/modules/setting/business/payment/payment-mobile-messages.html",
], function (
    // Libs
    _,
    Backbone,
    Mustache,
    U,
    DEBUG,
    Toastr,
    // Services
    i18n,
    API,
    Session,
    //models
    MPaymentMethod,
    // views
    VModal,
    VPaymentCurrentPlan,
    VPaymentSafetyNotice,
    VPaymentMethodForm,
    VPaymentInformationsForm,
    VBillingInformationsForm,
    VInfoSection,
    //templates
    TPaymentAddMethodModal,
    TPaymentMessages,
    TPaymentMobileMessages
) {
    var VPaymentAddMethodModal = VModal.extend({
        template: TPaymentAddMethodModal,
        regions: {
            currentPlan: ".payment-current-plan",
            safetyNotice: ".payment-method-safety-notice",
            paymentMethod: ".payment-method-form",
            paymentMessages: ".payment-messages",
            paymentMobileMessages: ".payment-mobile-messages",
            paymentInformations: ".payment-information-form",
            billingInformations: ".billing-information-form",
        },

        modal: function () {
            return {
                closeButton: false,
                title: i18n.t("payment:add_payment_method"),
                size: "medium",
                buttons: this.buttonsDefinition,
            };
        },

        initialize: function (opt) {
            window.modalInstance = this;
            this.options = _.extend(
                {
                    continueWithRedirection: true,
                },
                opt
            );

            var planToDisplay = this.options.currentPlanModel;
            if (this.options.pendingPlanModel) {
                planToDisplay = this.options.pendingPlanModel;
            }

            this.buttonsDefinition = {
                closeModal: {
                    label: i18n.t("general:Cancel"),
                    callback: this.onCancel,
                },
                save: {
                    label: i18n.t("payment:save_paypal_method"),
                    callback: this.onSave,
                },
            };

            var model = (this.model = new MPaymentMethod()),
                view = (this.view = {
                    currentPlan: new VPaymentCurrentPlan({
                        currentPlan: planToDisplay,
                        teamPaymentModel: this.options.teamPaymentModel,
                        standalone: this.options.standalone,
                    }),
                    safetyNotice: new VPaymentSafetyNotice({}),
                    paymentMessages: new VInfoSection({
                        hideTitleSection: true,
                        content: TPaymentMessages,
                    }),
                    paymentMobileMessages: new VInfoSection({
                        hideTitleSection: true,
                        content: TPaymentMobileMessages,
                    }),
                    paymentMethod: new VPaymentMethodForm({ model: model }),
                    paymentInformations: new VPaymentInformationsForm({
                        model: model,
                    }),
                    billingInformations: new VBillingInformationsForm({
                        model: model,
                    }),
                });

            this.listenTo(
                model,
                "change:paymentType",
                this.onPaymentTypeChange
            );
            this.listenTo(
                view.currentPlan,
                "click:changePlan",
                this.onChangePlanClick
            );
        },

        render: function () {
            var html = Mustache.render(
                this.template,
                Mustache.getContext({
                    team_name: this.options.teamPaymentModel.getName(),
                })
            );

            this.$el.empty().append(html);

            this.generateRegions();

            // Payement unavailable on mobile app
            if (window.cordova) {
                this.adaptMobileDisplay();
                this.renderModal();
            } else {
                this.buttonsDefinition.closeModal.callback = this.onCancel;
                this.buttonsDefinition.save.callback = this.onSave;

                this.renderModal();
                this.onPaymentTypeChange(this.model);
            }

            return this;
        },

        generateRegions: function () {
            this.generateZones()
                .assign(this.view.currentPlan, this.zone.$currentPlan)
                .assign(this.view.safetyNotice, this.zone.$safetyNotice)
                .assign(this.view.paymentMessages, this.zone.$paymentMessages)
                .assign(
                    this.view.paymentMobileMessages,
                    this.zone.$paymentMobileMessages
                )
                .assign(this.view.paymentMethod, this.zone.$paymentMethod)
                .assign(
                    this.view.paymentInformations,
                    this.zone.$paymentInformations
                )
                .assign(
                    this.view.billingInformations,
                    this.zone.$billingInformations
                );
        },

        show: function (model) {
            this.render();
        },

        updateOptions: function (options) {
            this.options.teamPaymentModel = options.teamPaymentModel;
            this.options.currentPlanModel = options.currentPlanModel;

            this.view.currentPlan.updateOptions(options);
        },

        resetFieldsState: function (options) {
            this.view.paymentInformations.resetFieldsState();
            this.view.billingInformations.resetFieldsState();
        },

        processPayment: function (url, data) {
            return Backbone.ajax(
                _.extend(
                    {
                        url: url,
                        method: "POST",
                        dataType: "json",
                        contentType: "application/json",
                        data: JSON.stringify(data),
                        context: this,
                    },
                    {
                        error: function (jqXHR, textStatus, errorThrown) {
                            this.exitWaitingState();
                        },
                        success: function (response, textStatus, jqXHR) {
                            if (this.options.profile !== undefined) {
                                this.options.profile.set(
                                    "needPaymentCenter",
                                    false
                                );
                                this.options.profile.save(
                                    { needPaymentCenter: false },
                                    _.extend(
                                        {
                                            patch: true,
                                            context: this,
                                            validate: false,
                                        },
                                        null
                                    )
                                );
                            }

                            if (this.options.continueWithRedirection) {
                                window.location.replace(response);
                            } else {
                                this.exitWaitingState();
                                this.options.teamPaymentModel.fetch();

                                Toastr.success(
                                    i18n.t(
                                        "payment:finishing_payment_process_success_message"
                                    ),
                                    i18n.t(
                                        "payment:finishing_payment_process_success_title"
                                    ),
                                    {
                                        positionClass: "toast-top-center",
                                        newestOnTop: false,
                                        showMethod: "slideDown",
                                        tapToDismiss: false,
                                        closeButton: true,
                                    }
                                );

                                if (this.options.standalone) {
                                    Backbone.history.redirect("supervisor");
                                }

                                this.close();
                            }
                        },
                    }
                )
            );
        },

        enterWaitingState: function () {
            var saveButton = this.$modal.find(".btn-primary");
            saveButton.toggleDisabled();

            this.view.paymentMessages.$el.toggleClass("hidden", false);
        },

        exitWaitingState: function () {
            var saveButton = this.$modal.find(".btn-primary");
            saveButton.toggleDisabled();

            this.view.paymentMessages.$el.toggleClass("hidden", true);
        },

        adaptMobileDisplay: function () {
            this.view.safetyNotice.toggleDisplay(false);
            this.view.paymentMethod.toggleDisplay(false);
            this.view.paymentInformations.toggleDisplay(false);
            this.view.paymentMobileMessages.$el.toggleClass("hidden", false);

            this.buttonsDefinition = {
                closeModal: {
                    label: i18n.t("Close"),
                    callback: this.onCancel,
                },
            };
        },

        getPaymentMethod: function () {
            return "pay";
        },

        getPaypalPostData: function () {
            return {};
        },

        ////////////
        // events //
        ////////////
        onHidden: function () {
            this.options.continueWithRedirection = false;
            this.exitWaitingState();
        },

        onCancel: function () {
            if (this.options.standalone) {
                Backbone.history.redirect("auth/logout");
            }

            this.close();
        },

        onSave: function (confirmed) {
            var url = Mustache.render(this.model.urlRoot, {
                payId: this.options.teamPaymentModel.id,
                method: this.getPaymentMethod(), //'pay' or 'update'
                paymentType: this.model.getPaymentType(), //'Credit card' or 'paypal'
            });

            var data = {};

            this.enterWaitingState();

            if (this.model.isCreditCardPayment()) {
                window.modalInstance.resetFieldsState();
                if (this.model.isValid({ singleError: true })) {
                    data = {
                        method: {
                            card_type: this.model.getCardType(),
                            card_number: this.model.getCardNumber(),
                            card_expire_month:
                                this.model.get("expirationMonth"),
                            card_expire_year: this.model.get("expirationYear"),
                            card_security: this.model.getSecurityCode(),

                            cardholder: {
                                firstName: this.model.get("firstName"),
                                middleName: this.model.get("middleName"),
                                lastName: this.model.get("lastName"),
                                addressLine1: this.model.get("addressLine1"),
                                addressLine2: this.model.get("addressLine2"),
                                city: this.model.get("city"),
                                phoneNumber: this.model.get("phoneNumber"),
                                country: this.model.get("country"),
                                region: this.model.get("region"),
                                postalCode: this.model.get("postalCode"),
                            },
                        },
                    };
                    this.processPayment(url, data);
                } else {
                    this.exitWaitingState();
                }
            } else {
                data = this.getPaypalPostData();
                this.options.continueWithRedirection = true;
                this.processPayment(url, data);
            }

            return false;
        },

        onPaymentTypeChange: function (model) {
            var saveButton = this.$modal.find(".btn-primary");
            var waitingText = this.$modal.find(".payment-waiting-message");

            if (model.isCreditCardPayment()) {
                this.view.paymentInformations.toggleDisplay(true);
                this.view.billingInformations.toggleDisplay(true);
                saveButton.html(i18n.t("payment:save_credit_card_method"));
                waitingText.html(i18n.t("payment:message_credit_card_payment"));
                this.options.continueWithRedirection = false;
            } else {
                this.view.paymentInformations.toggleDisplay(false);
                this.view.billingInformations.toggleDisplay(false);
                saveButton.html(i18n.t("payment:save_paypal_method"));
                waitingText.html(i18n.t("payment:message_paypal_redirection"));
                this.options.continueWithRedirection = true;
            }
        },

        onChangePlanClick: function () {
            this.close();
            this.options.teamPaymentModel.collection.trigger(
                "payment:modify-plan",
                this.options.teamPaymentModel
            );
        },
    });

    return VPaymentAddMethodModal;
});

